module.exports = __webpack_public_path__ + "sq5-1525c296.png";